module.exports = __webpack_public_path__ + "img/teamImg26.1d5c90f7.png";